import axios from 'axios';
import ServerProperties from '../config/server.js'

export default {
  ReadAsMaster: function(params) {
    axios.defaults.headers.common['Authorization'] = "Bearer "+params.data.AuthorizationToken;
    axios.get(ServerProperties.ATM_CLOUD.API + params.data.query)
    .then(function (response) {
      params.onsuccess(params, response);
    })
    .catch(error => {            
      params.onfailed(error)
    });
  },
  Read: function(params) {
    axios.defaults.headers.common['Authorization'] = "Bearer "+params.data.AuthorizationToken;
    axios.get( 
      ServerProperties.ATM_CLOUD.API+'Maintenance/Work/?status=' + params.data.status+ '&' + params.data.order + '&' + params.data.filter + '&page=' + params.data.page,
      params.data
    )
    .then(function (response) {
      params.onsuccess(params, response);
    })
    .catch(error => {
      params.onfailed(params, error)
    });
  },
  ReadByAsset: function(params) {
    axios.defaults.headers.common['Authorization'] = "Bearer "+params.data.AuthorizationToken;
    axios.get( 
      ServerProperties.ATM_CLOUD.API+ params.data.api + params.data.query+ '/?page=' + params.data.page,
    )
    .then(function (response) {
      params.onsuccess(params, response);
    })
    .catch(error => {
      params.onfailed(error)
    });
  },
  Register: function(params) {
    axios.defaults.headers.common['Authorization'] = "Bearer "+params.data.AuthorizationToken;
    axios.post(
      ServerProperties.ATM_CLOUD.API + 'Maintenance/Work/Register/', 
      params.data
    )
    .then(function(response) {
      params.onsuccess(params, response)
    })
    .catch(error => {
      params.onfailed(error)
    });
  },
  RequestMaintenance: function(params) {
    axios.defaults.headers.common['Authorization'] = "Bearer "+params.data.AuthorizationToken;
    axios.post(
      ServerProperties.ATM_CLOUD.API + 'Maintenance/Request/Register/',
      params.data.field
    )
    .then(function (response) {
      params.onsuccess(params, response)
    })
    .catch(error => {
      // if(error.response) {
        params.onfailed(error.response)
      // } 
    });
  },
  RegisterReport: function(params) {
    axios.defaults.headers.common['Authorization'] = "Bearer "+params.data.AuthorizationToken;
    axios.post(
      ServerProperties.ATM_CLOUD.API + 'Maintenance/Report/Register/',
      params.data.field
    )
    .then(function (response) {
      params.onsuccess(params, response)
    })
    .catch(error => {
      params.onfailed(error.response)
    });
  },
  Update: function(params) {
    axios.defaults.headers.common['Authorization'] = "Bearer "+params.data.AuthorizationToken;
    axios.put(
      ServerProperties.ATM_CLOUD.API + 'Maintenance/Work/Update/' + params.data.Alias + '/', 
      params.data.field
    )
    .then(function(response) {
      params.onsuccess(params, response)
    })
    .catch(error => {
      params.onfailed(error.response)
    });
  },
  StartWork: function(params) {
    axios.defaults.headers.common['Authorization'] = "Bearer "+params.data.AuthorizationToken;
    axios.patch( 
      ServerProperties.ATM_CLOUD.API + 'Maintenance/Work/Start/' + params.data.alias + '/',
      {
        Contractor : params.data.contractor
      }
    )
    .then(function (response) {
      params.onsuccess(params, response);
    })
    .catch(error => {
        params.onfailed(error.response)
    });
  },
  QuickTest: function(params) {
    axios.defaults.headers.common['Authorization'] = "Bearer "+params.data.AuthorizationToken;
    axios.patch( 
      ServerProperties.ATM_CLOUD.API + 'Maintenance/Work/StartQuick/' + params.data.alias + '/',
      {
        Contractor : params.data.contractor
      }
    )
    .then(function (response) {
      params.onsuccess(params, response);
    })
    .catch(error => {
        params.onfailed(error.response)
    });
  },
  FinishWork: function(params) {
    axios.defaults.headers.common['Authorization'] = "Bearer "+params.data.AuthorizationToken;
    axios.patch( 
      ServerProperties.ATM_CLOUD.API + 'Maintenance/Work/Finish/' + params.data.Alias + '/',
      params.data.Data,{
        headers: {
          'content-type': 'multipart/form-data'
        }
      }
    )
    .then(function (response) {
      params.onsuccess(params, response);
    })
    .catch(error => {
        params.onfailed(error.response)
    });
  },
  RegisterReminder: function(params) {
    axios.defaults.headers.common['Authorization'] = "Bearer "+params.data.AuthorizationToken;
    axios.post(
      ServerProperties.ATM_CLOUD.API + 'Maintenance/Reminder/Register/', 
      params.data.field
    )
    .then(function(response) {
      params.onsuccess(params, response)
    })
    .catch(error => {
      params.onfailed(error.response)
    });
  },
  UpdateReminder: function(params) {
    axios.defaults.headers.common['Authorization'] = "Bearer "+params.data.AuthorizationToken;
    axios.put(
      ServerProperties.ATM_CLOUD.API + 'Maintenance/Reminder/Update/' + params.data.Work + '/', 
      params.data.field
    )
    .then(function(response) {
      params.onsuccess(params, response)
    })
    .catch(error => {
      params.onfailed(error)
    });
  },
  ReadReminderByWork: function(params) {
    axios.defaults.headers.common['Authorization'] = "Bearer "+params.data.AuthorizationToken;
    axios.get( 
      params.data.url === undefined ? ServerProperties.ATM_CLOUD.API+ 'Maintenance/Reminder/Work/' + params.data.query+ '/' : params.data.url,
    )
    .then(function (response) {
      params.onsuccess(params, response);
    })
    .catch(error => {
        params.onfailed(error)
    });
  }
}


// WEBPACK FOOTER //
// ./src/App/maintenance/model.js